const simulationsData = [
    {
        id: 1,
        name: "Falling Ball Simulation",
        imageSrc: require('../images/simulation1.png'),
        link: "/falling-fall-simulation",
    },
    {
        id: 2,
        name: "Solar System Simulation",
        imageSrc: require('../images/simulation2.png'),
        link: "/solar-system-simulation",
    },
    {
        id: 3,
        name: "Light Through Prism Simulation",
        imageSrc: require('../images/simulation3.png'),
        link: "/prism-simulation",
    }
];

export default simulationsData;